export const ACCOUNT_NUMBER_REGEX = /^\d{8}$/;
export const SORT_CODE_REGEX = /^\d{6}$/;
